import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
/**
 * Generated class for the SetupInitalData2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-setup-initial-3',
    templateUrl: 'setup-initial-3.html',
})
export class SetupInital3Page {

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private globals: Globals,
        public translate: TranslateService,
        private http: HttpClient,
        public toastCtrl: ToastController,) {
    }

    ionViewWillEnter() { }

    reload() {
        window.location.reload();
    }

    payPro() {
        this.globals.openPayProMonthBlank();
    }

    payBasic() {
        this.globals.openPayBasicMonthBlank();
    }

    async sendSlack() {

        //generate msg
        var msg = 'Setup personalizado, establecimiento ' + this.globals.user_email;
        //send
        await this.http.post(this.globals.api_path + 'slack/register', {
            msg: msg,
        }, {}).subscribe(async data => {
        },
            err => {
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/setup/setup-initial-3/setup-initial-3.ts